import type { ReactNode } from "react";

import { Box } from "../../Box/Box";
import { Text } from "../../Text/Text";
import type { StylesOptions } from "../../hooks/useStyles";

/**
 * @beta
 */
export function ListboxLoadingMessage({
  children,
  styles,
}: { children?: ReactNode } & StylesOptions) {
  return (
    <Box px="sp-16" py="sp-8" styles={styles}>
      <Text color="gray-60">
        {children || (
          <>
            <Text>Загрузка</Text>
            <Text aria-hidden>...</Text>
          </>
        )}
      </Text>
    </Box>
  );
}
